enum ErrorSuggestions {
	//TODO: After development is done
	//TODO: Merge with ErrorCodes from front-applet and add to the lib
	FILE_IS_ALREADY_LOADING = 'Please, check your code for multiple occurrences of addFile/s methods.',
	FILE_ALREADY_EXISTS = 'Please, check your code for occurrences of addFile/s methods on lines before this error.',
	FILE_NOT_FOUND = 'Please, check if the used URL is correct.',
	SECURITY_PIN_CODE_NOT_SET_YET = 'Try again later or setPinCode by yourself first.',
}

export default ErrorSuggestions;
